import React, { useContext, useState, useEffect } from "react"
import { makeStyles } from "@material-ui/styles"
import { ButtonBase, Typography } from "@material-ui/core"
import { FormattedMessage, injectIntl } from "react-intl"
import { NumberSelect, CartContext } from ".."
import { Moltin } from "../../puraearth/src/services/Moltin"
import { Link } from "gatsby"

const localeConsts = require("../../constants/localeConsts")
const useStyles = makeStyles(theme => {
  return {
    root: {
      alignItems: "center",
      display: "flex",
      marginBottom: theme.spacing(3),
      opacity: props => props.removed && 0.5,
      transition: "opacity 0.25s",
    },
    imageWrapper: {
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: theme.palette.black.supportLight,
      width: theme.spacing(14),
      height: theme.spacing(15),
    },
    infoContainer: {
      alignItems: "flex-start",
      alignSelf: "stretch",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      padding: theme.spacing(1, 0, 2, 3),
    },
    price: {
      fontWeight: "bold",
    },
    remove: {
      marginTop: "7px",
      textDecoration: "underline",
    },
    image: {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
    link: {
      color: theme.palette.green.main,
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    subContainer: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      marginTop: "7px",
    },
    priceContaier: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-evenly",
    },
    out_of_stock: {
      color: theme.palette['red'].main,
      textTransform: "uppercase"
    }
  }
})

const useSlug = id => {
  const [result, setResult] = useState("/")
  useEffect(() => {
    ;(async () => {
      const {
        data: { slug },
      } = await Moltin.Products.Get(id)
      setResult("/" + slug)
    })()
  }, [])
  return result
}

export default injectIntl(props => {
  const { locale } = props.intl
  const maxQuantity = 10
  const [removed, setRemoved] = useState(false)
  const newProps = { removed: removed, ...props }
  const classes = useStyles(newProps)
  const { updateQuantity, removeFromCart } = useContext(CartContext)

  const slug = useSlug(props.productId)
  const handleClick = () => {
    setRemoved(true)
    setTimeout(() => {
      removeFromCart(props.id)
    }, 500)
  }
  const handleChange = value => {
    updateQuantity(props.id, value)
  }
  return (
    <div className={classes.root}>
      <div className={classes.imageWrapper}>
        <img className={classes.image} src={props.imageHref} alt={""} />
      </div>
      <div className={classes.infoContainer}>
        <Link
          to={
            locale === localeConsts.es
              ? `/${locale + slug + localeConsts.esPath}`
              : `/${locale + slug + localeConsts.enPath}`
          }
          className={classes.link}
        >
          <Typography variant={"body1"} component={"h2"}>
            {props.name}
          </Typography>
        </Link>
        <div className={classes.subContainer}>
          <div className={classes.priceContaier}>
            <Typography
              classes={{ root: classes.price }}
              variant={"body1"}
              component={"div"}
            >
              {props.price}
            </Typography>

            {props.isOutOfStock &&
            <Typography classes={{ root: classes.out_of_stock }} variant={'span'} component={'span'}>
              {props.outOfStock}
            </Typography>
            }

            <ButtonBase
              disabled={removed}
              onClick={handleClick}
              classes={{ root: classes.remove }}
            >
              <Typography variant={"body1"} component={"div"}>
                <FormattedMessage id="remove" />
              </Typography>
            </ButtonBase>
          </div>
          <NumberSelect
            start={1}
            length={maxQuantity}
            horizontal
            disabled={removed || props.isOutOfStock}
            value={props.quantity}
            width={9}
            hideLabel
            hideHelperText
            label={"Quantity"}
            labelVariant={"body1"}
            labelColor={"black"}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  )
})
